import Api from 'api'

const config = {
  baseURL: '/api/app/v2/advertising-types',
}
const api = new Api(config)

api.fetchAll = ({ ...rest }) => api.get('', { ...rest })

export default api
